import PropTypes from 'prop-types';
import React, { useCallback, useMemo, useContext } from 'react';
import I18n from 'i18n-js';
import cx from 'classnames';
import { Button } from 'grab-ui';
import _get from 'lodash/get';
import OfferPanelContext from './offer-panel-context';
import styles from './styles.less';
import { getOfferID } from '../../../../../helper/anytime-booking';

const OfferListFooter = ({
  onClose,
  selectedOffer,
  offerList,
  offerConfig,
  isPromoSearch,
}) => {
  const {
    setOfferConfig,
    errorMessage,
    handleScribeApplyOffer,
    handleScribeContinueWithoutOffer,
  } = useContext(OfferPanelContext);
  const isOfferAvailable =
    _get(selectedOffer, 'validationMeta.status') === 'AVAILABLE';

  const handlerApplyOffer = useCallback(
    () => {
      if (selectedOffer) {
        setOfferConfig(selectedOffer);
        onClose();
        handleScribeApplyOffer({ isPromoSearch, isOfferAvailable });
      }
    },
    [
      setOfferConfig,
      handleScribeApplyOffer,
      onClose,
      selectedOffer,
      isPromoSearch,
      isOfferAvailable,
    ],
  );

  const handleRemoveOffer = useCallback(
    () => {
      setOfferConfig(null);
      handleScribeContinueWithoutOffer();
      onClose();
    },
    [setOfferConfig, onClose, handleScribeContinueWithoutOffer],
  );

  const hasChooseOffer = useMemo(
    () => !!(offerConfig && getOfferID(offerConfig)),
    [offerConfig],
  );

  const showButtonRemoveOffer = useMemo(
    () => {
      if (
        !!errorMessage &&
        offerConfig &&
        selectedOffer &&
        getOfferID(offerConfig) === getOfferID(selectedOffer)
      ) {
        return true;
      }
      return !selectedOffer && hasChooseOffer;
    },
    [offerConfig, selectedOffer, errorMessage, hasChooseOffer],
  );

  const showFooter = useMemo(
    () => {
      if (!offerList || offerList.length === 0) {
        return false;
      }
      return showButtonRemoveOffer || !!selectedOffer;
    },
    [offerList, selectedOffer, showButtonRemoveOffer],
  );

  if (!showFooter) {
    return null;
  }

  return showButtonRemoveOffer ? (
    <div className={styles.footerWrapper}>
      <Button
        onClick={handleRemoveOffer}
        className={cx(styles.confirmButton, styles.continueWithoutOffer)}
      >
        {I18n.t(
          'phrase.offers.mktplace_offers_button_continue_without_offer_edge_case',
        )}
      </Button>
    </div>
  ) : (
    <div className={styles.footerWrapper}>
      {!!selectedOffer && (
        <div className={styles.buttonWrapper} key="buttonWrapper-footer">
          <Button
            type="primary"
            onClick={handlerApplyOffer}
            className={styles.confirmButton}
          >
            {I18n.t(
              'phrase.offers.mktplace_offers_bottom_sheet_button_miscellaneous',
            )}
          </Button>
        </div>
      )}
    </div>
  );
};

OfferListFooter.defaultProps = {
  onClose: undefined,
  selectedOffer: undefined,
  offerList: undefined,
  offerConfig: undefined,
  isPromoSearch: false,
};

OfferListFooter.propTypes = {
  onClose: PropTypes.func,
  selectedOffer: PropTypes.shape({}),
  offerList: PropTypes.arrayOf(PropTypes.shape({})),
  offerConfig: PropTypes.shape({}),
  isPromoSearch: PropTypes.bool,
};

export default OfferListFooter;
